import Vue from 'vue'

import store from '@/store'

const state = {
  commande: {
    idCommande: 0,
    lignes: [],
    sousTotal: 0,
    montantCommande: 0,
    tps: 0,
    tvq: 0,
    total: 0,
    nbBouteilles: 0,
    nbCaisses: 0
  }
}

const getters = {
  // Acces via  this.$store.getters.commande
  commande(state) {
    return state.commande
  },
  lignes(state) {
    return state.commande == null ? null : state.commande.lignes
  }
}

const actions = {
  // Commande
  initialiserCommande({ commit }) {
    commit('initialiserCommande')
  },
  // Lignes
  ajouterProduitLot({ commit }, listeProduitData) {
    commit('mAjouterProduitLot', listeProduitData)
  },
  supprimerLigne({ commit }, ligne) {
    commit('mSupprimerLigne', ligne)
  },
  modifierQte({ commit }, ligne) {
    commit('mModifierQte', ligne)
  }
}

const mutations = {
  // Commande
  initialiserCommande(state) {
    state.commande = {
      idCommande: 0,
      lignes: [],
      sousTotal: 0,
      montantCommande: 0,
      tps: 0,
      tvq: 0,
      total: 0,
      nbBouteilles: 0,
      nbCaisses: 0
    }
  },
  mGarderCommande(state, commandeTPData) {
    state.commande = commandeTPData

    // Si les enfant n'existent pas, on les initialize
    if (commandeTPData.lignes == null) {
      state.commande.lignes = []
    }
  },
  // Produits
  mAjouterProduitLot(state, listeProduitData) {
    for (let p = 0; p < listeProduitData.length; p++) {
      let produitData = listeProduitData[p]

      if (produitData.arretVente == 'Y') {
        console.log(produitData.arretVente)
        continue
      }

      // Le produit est-il deja dans la liste? Si oui, on recupere la qteExistante..
      let index = -1
      for (let i = 0; i < state.commande.lignes.length; i++) {
        if (state.commande.lignes[i].noProduit === produitData.noProduit) {
          index = i
          break
        }
      }

      // Le produit existe, ajout de la qte sur la ligne existante
      if (index >= 0) {
        let ligne = state.commande.lignes[index]

        if (ligne.produitData != null) {
          ligne.prix = ligne.produitData.prix

          ligne.quantite = Number(1)
          ligne.total = ligne.produitData.prix * ligne.quantite
        } else {
          ligne.quantite = Number(1)
          ligne.total = ligne.prix * ligne.quantite
        }

        Vue.set(state.commande.lignes, index, ligne)
      } else {
        // Le produit n'existe pas deja, on l'ajoute
        let ligne = produitData

        if (ligne.produitData != null) {
          ligne.prix = ligne.produitData.prix

          if (!produitData.quantite) {
            ligne.quantite = Number(1)
          }
          ligne.total = ligne.produitData.prix * ligne.quantite
        } else {
          if (!produitData.quantite) {
            ligne.quantite = Number(1)
          }
          ligne.total = ligne.prix * ligne.quantite
        }

        state.commande.lignes.push(ligne)
      }
    }
    // Tri + calcul totaux
    //state.commande.lignes.sort((a, b) => a.noProduit - b.noProduit)
    calculerTotauxSansTaxes(state)
  },
  mSupprimerLigne(state, ligne) {
    const index = state.commande.lignes.indexOf(ligne)
    state.commande.lignes.splice(index, 1)
    calculerTotauxSansTaxes(state)
  },

  mModifierQte(state, ligne) {
    const index = state.commande.lignes.indexOf(ligne)
    let l = state.commande.lignes[index]
    l.quantite = +ligne.quantite
    l.total = ligne.prix * l.quantite
    Vue.set(state.commande.lignes, index, l)
    calculerTotauxSansTaxes(state)
  }
}

// -------
// Helpers
// -------

function calculerTotauxSansTaxes(state) {
  let lignes = state.commande.lignes
  let nbBouteilles = 0
  let nbCaisses = 0
  let sousTotal = 0
  for (let i = 0; i < lignes.length; i++) {
    nbBouteilles += Number(lignes[i].quantite)
    nbCaisses += Number(lignes[i].quantite) / Number(lignes[i].uvc)
    sousTotal += Number(lignes[i].total)
  }

  state.commande.sousTotal = sousTotal
  state.commande.nbBouteilles = nbBouteilles
  state.commande.nbCaisses = Math.ceil(nbCaisses)

  Vue.$axios
    .get('/taxes/extraire/' + sousTotal)
    .then(response => {
      let resp = response.data
      if (resp.codeRetour == 'OK') {
        let r = resp.resultat
        state.commande.montantCommande = r.montantTotal
        state.commande.tps = r.montantTPS
        state.commande.tvq = r.montantTVQ
      } else {
        let msg = Vue.prototype.$fmtApiErr(resp)
        console.log(msg)
        store.dispatch('afficherError', msg)
      }
    })
    .catch(error => {
      console.log('error=' + error)
      let msg = Vue.prototype.$fmtAxiosErr(error)
      store.dispatch('afficherError', msg)
    })
}

export default {
  state,
  mutations,
  getters,
  actions
}
